import { Box, Typography, Link, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IndependentExpenditureTable from './IndependentExpenditureTable';

const IndependentExpenditure = (): JSX.Element => {

    return (
        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Independent Expenditures
            </Typography>
            <Typography variant="body1" component={'p'} marginBottom={2} gutterBottom>
                An independent expenditure is an expenditure made or liability incurred by an individual, group, association, corporation, labor union, political committee or other entity as payment for goods or services to expressly advocate the election or defeat of a clearly identified candidate; provided, however, that the expenditure is made or incurred without cooperation or consultation with any candidate or a nonelected political committee organized on behalf of the candidate or an agent of the candidate and is not made or incurred in concert with or at the request or suggestion of the candidate, a nonelected political committee organized on behalf of the candidate or agent of the candidate.
            </Typography>
            <Typography variant="body1" component={'p'} marginBottom={2} gutterBottom>
                Independent expenditures that are made to support or oppose candidates who file with OCPF e-file independent expenditure reports with OCPF. Click <Link underline="none" href="https://www.ocpfreporter.us/Account/Register" target="_blank">here</Link> to register to file an Independent Spending Report.
            </Typography>
            <Typography variant="body1" component={'p'} marginBottom={2} gutterBottom>
                Independent expenditures that are made to support or oppose municipal candidates (non-OCPF filers) file the <Link href='https://ocpf2.blob.core.windows.net/pdf/forms/cpf_m18a_2018.pdf?t=ndCsZ5m' target='_blank'>Form CPF M 18A Report</Link> with local election officials.
            </Typography>
            <Typography variant="body1" component={'p'} marginBottom={2} gutterBottom>
                <i>
                    OCPF issued <Link href='https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-10-03.pdf' target='_blank'>IB-10-03</Link> to provide guidance to entities that raise funds solely for the purpose of making independent expenditures supporting or opposing candidates.  Such groups must organize as an <b>Independent Expenditure Political Action Committee (IE PAC)</b>.
                </i>
            </Typography>
            <Accordion sx={{ marginBottom: 3 }} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" marginBottom={1}><b>Filing Schedules</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <IndependentExpenditureTable />
                </AccordionDetails>
            </Accordion>

        </Box>





    )
};

export default IndependentExpenditure;